import { RxCross2 } from "react-icons/rx"; 
import { GiSplitCross } from "react-icons/gi"; 
import React, { useEffect, useState } from 'react';
import { FaSignOutAlt, FaBars } from 'react-icons/fa';
import logo from '../assets/newLogo.png';
import toast from "react-hot-toast";
import { NavLink, useNavigate } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { setSidebar } from '../redux/slices/SliderSlice';

const Navbar = () => {
  const { login } = useSelector((state) => state.sidebar);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [openModal, setOpenModal] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  
 
   console.log(login,"adminnnn");
  const handleLogOut = () => {
    localStorage.clear();
    toast.success("Logged out successfully");
    dispatch(setSidebar(false));
    setOpenModal(false);
    navigate('/login');
  }

  const toggleModal = () => {
    setOpenModal(!openModal);
  }

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  }

  useEffect(() => { }, []);

  return (
    <nav className="bg-gray-800 p-4 flex z-40 fixed w-full justify-between items-center px-4">
      <div className="text-white text-xl font-bold z-40 opacity-100 flex items-center">
        <NavLink to="/home">
          <img src={logo} width={60} className="md:w-20" alt="Logo" /> {/* Increase size for desktop */}
        </NavLink>
      </div>

      {/* Hamburger menu for mobile */}
      <button className="text-white md:hidden" onClick={toggleSidebar}>
        <FaBars className="text-2xl" />
      </button>

      {/* Navbar Links for Desktop */}
    { login &&  <div className="hidden md:flex space-x-10 text-lg font-medium bg-opacity-90 text-white">
  <NavLink 
    to="/home" 
    className="hover:opacity-100 hover:scale-110 transition-all duration-300 ease-in-out">
    Home
  </NavLink>
  <NavLink 
    to="/contact" 
    className="hover:opacity-100 hover:scale-110 transition-all duration-300 ease-in-out">
    Contact
  </NavLink>
  <NavLink 
    to="/about" 
    className="hover:opacity-100 hover:scale-110 transition-all duration-300 ease-in-out">
    About Us
  </NavLink>
  <NavLink 
    to="/terms" 
    className="hover:opacity-100 hover:scale-110 transition-all duration-300 ease-in-out">
    Terms of Service
  </NavLink>
  <NavLink 
    to="/privacy" 
    className="hover:opacity-100 hover:scale-110 transition-all duration-300 ease-in-out">
    Privacy Policy
  </NavLink>
  {login && (
    <button 
      className="text-white flex items-center hover:opacity-100 hover:scale-110 transition-all duration-300 ease-in-out" 
      onClick={toggleModal}>
      <FaSignOutAlt className="mr-2" />
      Logout
    </button>
  )}
</div>}


      {/* Sidebar for Mobile */}
      {isSidebarOpen && (
        <div className="fixed inset-0 z-50 bg-black bg-opacity-50 md:hidden" onClick={toggleSidebar}>
          <div className="bg-gray-800 w-64 h-full shadow-lg p-6 relative">
            <button className="text-white text-2xl font-semibold right-4 top-7 absolute " onClick={toggleSidebar}><RxCross2 /></button>
            <div className="space-y-6">
              <NavLink to="/home" className="block text-white text-xl font-medium hover:underline">Home</NavLink>
              <NavLink to="/contact" className="block text-white text-xl font-medium  hover:underline">Contact</NavLink>
              <NavLink to="/about" className="block text-white text-xl font-medium  hover:underline">About Us</NavLink>
              <NavLink to="/terms" className="block text-white text-xl font-medium  hover:underline">Terms of Service</NavLink>
              <NavLink to="/privacy" className="block text-white text-xl font-medium  hover:underline">Privacy Policy</NavLink>
              {login &&
                <button className="text-white flex items-center text-xl font-medium " onClick={toggleModal}>
                  <FaSignOutAlt className="mr-2" />
                  Logout
                </button>
              }
            </div>
          </div>
        </div>
      )}

      {/* Logout Confirmation Modal */}
      {openModal &&
        <div id="popup-modal" className="fixed inset-0 z-50 flex items-center justify-center w-full h-full bg-black bg-opacity-50">
          <div className="bg-white rounded-lg shadow dark:bg-gray-700 relative p-4 w-full max-w-md">
            <button
              type="button"
              className="absolute top-3 right-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 inline-flex items-center justify-center dark:hover:bg-gray-600 dark:hover:text-white"
              onClick={toggleModal}
            >
              <svg className="w-3 h-3" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 14">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 1l6 6m0 0l6 6M7 7l6-6M7 7l-6 6" />
              </svg>
              <span className="sr-only">Close modal</span>
            </button>
            <div className="p-4 md:p-5 text-center">
              <svg className="mx-auto mb-4 text-gray-400 w-12 h-12 dark:text-gray-200" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M10 11V6m0 8h.01M19 10a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
              </svg>
              <h3 className="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">Are you sure you want to log out?</h3>
              <button
                onClick={handleLogOut}
                type="button"
                className="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center"
              >
                Yes, I'm sure
              </button>
              <button
                type="button"
                className="py-2.5 px-5 ms-3 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
                onClick={toggleModal}
              >
                No, cancel
              </button>
            </div>
          </div>
        </div>
      }
    </nav>
  );
};

export default Navbar;
